import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { DeleteIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { PureComponent, forwardRef } from 'react';
import ImageUploadButton from 'components/core/image_upload_button';
const formatStringCss = "faiuzpd";
const FormatString = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formatStringCss, props.className)} />;
});
const wrapperWithImageIsTabletUpCss = "w5gacou";
const wrapperWithImageCss = "wjrqnl3";
const WrapperWithImage = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(wrapperWithImageCss, {
    [wrapperWithImageIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
export default class AvatarControls extends PureComponent {
  render() {
    if (this.props.imageExists) {
      return <WrapperWithImage>
          <ImageUploadButton decoration="secondary-outline" size="small" onFileSelect={this.props.onFileSelect} onFileError={this.props.onFileError} cropShape="round" cropRatio={1} validate={this.props.validate}>
            {I18n.t('publisher.action.update')}
          </ImageUploadButton>
          <Button decoration="ghost" size="small" onClick={this.props.onAvatarRemove}>
            <DeleteIcon />
            {I18n.t('publisher.action.remove')}
          </Button>
        </WrapperWithImage>;
    }
    return <div>
        <ImageUploadButton decoration="secondary-outline" size="small" onFileSelect={this.props.onFileSelect} onFileError={this.props.onFileError} cropShape="round" cropRatio={1} validate={this.props.validate}>
          {I18n.t('publisher.action.upload_picture')}
        </ImageUploadButton>
        <FormatString>
          {I18n.t('publisher.action.image_formats')}
        </FormatString>
      </div>;
  }
}

require("./avatar_controls.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./avatar_controls.js");